import React, { useState, useRef } from 'react';
import { useRouter } from 'next/router';
import cn from 'classnames';
import Form from 'react-scale/components/elements/hubspot-form';
import Modal from 'react-scale/components/tailwind/Modal';
import Button from 'react-scale/components/elements/button';

const ModalForm = ({
  campaign,
  label,
  title,
  formContainerCN,
  formId,
  theme,
  themeColors,
  type = 'primary',
  variant = 'default',
  size,
  fullWidth
}) => {
  const router = useRouter();
  const [showModal, setShowModal] = useState(false);
  const formWrapperRef = useRef();

  const toggleModal = () => {
    setShowModal(!showModal);
    if (campaign) {
      router.replace(`${router.pathname}?utm_campaign=${campaign}`);
    }
  };

  return (
    <div>
      <Button
        text={label}
        theme={theme}
        size={size}
        themeColors={themeColors}
        onClick={toggleModal}
        type={type}
        variant={variant}
        fullWidth={fullWidth}
      />
      <Modal
        title={title ?? label}
        isShowing={showModal}
        hide={() => setShowModal(false)}
        contentClassName="max-w-lg"
      >
        <div className={cn(formContainerCN)} ref={formWrapperRef}>
          <Form portalId="4823527" formId={formId} formContainerCN={`.${formContainerCN}`} />
        </div>
      </Modal>
    </div>
  );
};

ModalForm.defaultProps = {
  theme: 'light',
  label: 'Get Early Access',
  formId: 'cd4ebc8d-46b4-4068-9ffe-a308d84d10ae',
  formContainerCN: 'hubspot-subscribe', // custom className for when there are multiple modals in the same page
  campaign: null
};

export default ModalForm;
